import { authGet } from "@/core/services/auth-storage";

const Permissions = {
    install(Vue) {
      // Permission check method
      Vue.prototype.$hasPermission = function(requiredPermission) {
        // Non-staff and non-agent users (admins) have all permissions
        if (authGet('is_staff') !== '1' && authGet('is_agent') !== '1') {
          return true;
        }
  
        try {
          // Check staff permissions first
          if (authGet('is_staff') === '1') {
            const permissions = JSON.parse(authGet('staff_permissions') || '[]');
            return permissions.some(perm => perm.name === requiredPermission);
          }
          
          // Check agent permissions
          if (authGet('is_agent') === '1') {
            const permissions = JSON.parse(authGet('agent_permissions') || '[]');
            return permissions.some(perm => perm.name === requiredPermission);
          }
          
          return false;
        } catch (e) {
          console.error('Permission check error:', e);
          return false;
        }
      };
  
      // Check multiple permissions (all required)
      Vue.prototype.$hasAllPermissions = function(...requiredPermissions) {
        return requiredPermissions.every(perm => this.$hasPermission(perm));
      };
  
      // Check multiple permissions (any required)
      Vue.prototype.$hasAnyPermission = function(...requiredPermissions) {
        return requiredPermissions.some(perm => this.$hasPermission(perm));
      };
    }
  };
  
  export default Permissions;
